import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=5f190658&scoped=true&"
import script from "./detail2.vue?vue&type=script&lang=ts&"
export * from "./detail2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f190658",
  null
  
)

export default component.exports